module.exports = __webpack_public_path__ + "static/screenshot2-d19970978d70499e0f0060d3f1faf7d1.png";